export default function About() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto text-center">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-4">
          关于妖精动漫网
        </h2>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
          妖精动漫网创立于热爱漫画的初心，致力于为广大漫画爱好者打造一个免费、纯净、流畅的在线阅读空间。平台收录超过
          <strong className="text-primary-600 font-semibold">12,000部</strong>
          各类漫画作品，覆盖热血冒险、恋爱日常、悬疑推理、奇幻异世界、搞笑喜剧等全题材类型。我们坚持
          <strong className="text-primary-600 font-semibold">每日同步更新</strong>
          热门连载，确保读者第一时间追到最新章节。独特的
          <strong className="text-primary-600 font-semibold">下拉式阅读</strong>
          模式让你无需频繁翻页，像刷短视频一样轻松看漫画，沉浸感拉满。无论你是钟情于经典神作的老漫友，还是刚入坑寻找新番推荐的新读者，在妖精动漫网都能找到属于你的那本漫画。
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-accent-500"></i>
            安全纯净无广告弹窗
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-device-line text-accent-500"></i>
            手机电脑平板全适配
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line text-accent-500"></i>
            7×24小时稳定运行
          </span>
        </div>
      </div>
    </section>
  );
}